<template>
  <div class="modal fade" id="html-modal" role="dialog" data-backdrop="static" data-keyboard="false" @click.stop>
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <span v-html="message"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" @click="$emit('close')">{{ closeText }}</button>
          <button type="button" class="btn btn-warning" @click="$emit('confirm')">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: null
    },
    customHide: {
      type: Boolean,
      default: false
    },
    closeText: {
      type: String,
      default: '閉じる'
    },
    confirmText: {
      type: String,
      default: '登録する'
    }
  },
  mounted () {
    $('#html-modal').modal('show')
    if (this.customHide) {
      $('#html-modal').on('hidden.bs.modal', (e) => {
        $('body').attr('style', 'overflow: hidden !important')
      })
    }
  },
  beforeDestroy () {
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.modal-dialog {
  min-width: 500px;
  max-width: 800px;
}
.modal-footer {
  border-top: unset;
  background-color: #fff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalHtml.vue